import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";

import Header from "./components/Header/Header";
import Footer from "./components/Footer/Footer";

import Home from "./pages/Home";
import ReadyBuilds from "./pages/ReadyBuilds";
import Laptops from "./pages/Laptops";
import Components from "./pages/Components";
import Monitors from "./pages/Monitors";
import ProductPage from "./pages/ProductPage";
import AP from "./adminPanel/AP";

// Категории комплектующих
import Cpu from "./pages/components/Cpu";
import Gpu from "./pages/components/Gpu";
import Ram from "./pages/components/Ram";
import Storage from "./pages/components/Storage";
import Psu from "./pages/components/Psu";
import Cooling from "./pages/components/Cooling";
import Cases from "./pages/components/Cases";
import Motherboards from "./pages/components/Motherboards";
import Accessories from "./pages/Accessories"; // <-- добавили новый компонент

import { getProductsFromPubHtml } from "./utils/sheetsParser.js";


function App() {
  useEffect(() => {
    async function testFetch() {
      const products = await getProductsFromPubHtml(
        "https://docs.google.com/spreadsheets/d/e/2PACX-1vQ4a5i754OawbTZfxYwJhUMhK0UiTwMBCsHvybEz9x2G2MO0KiE9-Lrgfo8l30GEP72FpgdHu82nTdB/pub?gid=0&single=true&output=csv"
      );
      console.log("✅ Товары из Google Sheets:", products);
    }

    testFetch();
  }, []);

  return (
    <Router>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/ready-builds" element={<ReadyBuilds />} />
        <Route path="/ready-builds/:id" element={<ProductPage />} />
        <Route path="/laptops" element={<Laptops />} />
        <Route path="/laptops/:id" element={<ProductPage />} />
        <Route path="/components" element={<Components />} />
        <Route path="/components/cpu" element={<Cpu />} />
        <Route path="/components/gpu" element={<Gpu />} />
        <Route path="/components/ram" element={<Ram />} />
        <Route path="/components/storage" element={<Storage />} />
        <Route path="/components/psu" element={<Psu />} />
        <Route path="/components/cooling" element={<Cooling />} />
        <Route path="/components/cases" element={<Cases />} />
        <Route path="/components/motherboards" element={<Motherboards />} />
        <Route path="/components/:category/:id" element={<ProductPage />} />
        <Route path="/monitors" element={<Monitors />} />
        <Route path="/accessories" element={<Accessories />} /> {/* <-- новый маршрут */}
        <Route path="/accessories/:id" element={<ProductPage />} /> {/* <-- страница конкретного аксессуара */}
        <Route path="/admin/*" element={<AP />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
